require('../upsales/common/components/react/listAccounts.jsx');
require('../upsales/common/components/react/listActivities.jsx');
require('../upsales/common/components/react/listAppointment.jsx');
require('../upsales/common/components/react/table.jsx');
require('../upsales/common/components/react/listSoliditet.jsx');
require('../upsales/common/components/react/listOrders.jsx');
require('../upsales/common/components/react/viewPicker.jsx');
require('../upsales/common/components/react/accountChartSales.jsx');
require('../upsales/common/components/react/accountChartMarket.jsx');
require('../upsales/common/components/react/Loader.jsx');
require('../components/Flash/root.jsx');
require('../components/Flash/topList.jsx');
require('../components/Flash/shield.jsx');
require('../components/Flash/resultView.jsx');
require('../components/Flash/clockWidget.jsx');
require('../upsales/common/components/react/voice/root.jsx');
require('../upsales/common/components/react/voice/dialing.jsx');
require('../upsales/common/components/react/voice/inCall.jsx');
require('../upsales/common/components/react/voice/followup.jsx');
require('../upsales/common/components/react/inputs/inputWrappers.jsx');
require('../upsales/common/components/react/inputs/upCountry.jsx');
// Moved out of upsales/ for the React edit-activity modal port (WEB-8899);
// still required here because the Angular modal mounts them through the
// ReactTemplates.editActivity globals they register. root.jsx initialises the
// namespace, so it stays first.
require('../components/Flash/ActivityEditor/root.jsx');
require('../components/Flash/ActivityEditor/footer.jsx');
require('../components/Flash/ActivityEditor/sidebarAccount.jsx');
require('../components/Flash/ActivityEditor/sidebarContact.jsx');
require('../components/Flash/ActivityEditor/header.jsx');
require('../upsales/common/components/react/alerts/alerts.jsx');
require('../upsales/common/components/react/modals/AddProductCategory.jsx');
